import React from "react";
import { LegacyStack, Text, Banner } from "@shopify/polaris";

import { Provider, usePriceChanges } from "./Context";
import Table from "./Table";

const Loading = () => {
  return (
    <Text variant="bodyMd" as="span" color="subdued" alignment="center">
      Loading price changes...
    </Text>
  );
};

function Content(): React.JSX.Element {
  const { isLoading } = usePriceChanges();

  return (
    <LegacyStack spacing="loose" vertical>
      <Text variant="bodyMd" as="span" color="subdued">
        Review product price changes detected in your Shopify store. You can choose to apply these updates to
        active subscriptions or ignore them.
      </Text>

      <Banner status="info">
        Updating subscriptions changes only the line item base price. Selling plans, discounts, and billing
        schedules will not be modified. Updates run in the background. You will receive an email confirmation when
        complete.
      </Banner>

      {isLoading ? <Loading /> : <Table />}
    </LegacyStack>
  );
}

export default function PriceChanges(): React.JSX.Element {
  return (
    <Provider>
      <Content />
    </Provider>
  );
}
